// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3351":"0598a671","7492":"4a233324","9752":"03439ce9"}[chunkId] + ".chunk.css";
};